import { Controller } from "@hotwired/stimulus"
import { Tab } from "bootstrap"

// Connects to data-controller="browser-tab"
// Manages browser-specific instruction tabs in the import modal.
// Auto-detects the user's browser on connect and activates the matching tab.
// Each tab button carries a data-browser-tab-continuation attribute that controls
// the CSS counter on the token input list so step numbers remain correct.
export default class extends Controller {
  static targets = ["continuation", "chromeTab", "firefoxTab", "safariTab"]

  connect() {
    this.activateBrowserTab()
  }

  tabShown(event) {
    const n = Number(event.currentTarget.dataset.browserTabContinuation)
    this.setContinuation(n)
  }

  activateBrowserTab() {
    const ua = navigator.userAgent
    let tabTarget

    if (ua.includes("Firefox")) {
      tabTarget = this.firefoxTabTarget
    } else if (ua.includes("Safari") && !ua.includes("Chrome")) {
      tabTarget = this.safariTabTarget
    } else {
      tabTarget = this.chromeTabTarget
    }

    Tab.getOrCreateInstance(tabTarget).show()
  }

  setContinuation(n) {
    this.continuationTarget.classList.remove("list-continuation-4", "list-continuation-5")
    this.continuationTarget.classList.add(`list-continuation-${n}`)
  }
}
